export function updateProductPriceHtml(productObj, fromPrice = false) {
  $('.product-meta .wl-price-container').html(getPriceHtml(productObj.gross_price, 'gross', fromPrice));
  $('.product-meta .wl-price-container').append(getPriceHtml(productObj.rek_price, 'rek', fromPrice));
}

export function getPriceHtml(price, type = 'gross', fromPrice = false) {
  if (!price)
    return '';

  return `<span class="${type === 'rek' ? 'rek-product-price' : 'gross-product-price'} product-price wl-added wl-script-price">
            ${type === 'rek' ? productPageTranslations.rekPriceString : productPageTranslations.grossPriceString}
            ${fromPrice ? productPageTranslations.fromPriceString : ''}
            ${price}
          </span>`;
}

export function checkIfAvailable(container, sku) {
  const levplan = $(container).data('levplan');

  if (!levplan) return;
  if (sku in levplan) {
    return levplan[sku];
  }
  return false;
}

export function checkInStock(container, sku) {
  const inStock = $(container).data('in_stock');
  if (!inStock) return false;
  if (sku in inStock) {
    if (inStock[sku])
      return true;
    return false;
  }
  return false;
}

export function displayBundleDetails(sku, bundleParent) {
  $('.hidden-bundle-details', bundleParent).css('display', 'none');

  $('.hidden-bundle-product-sku', bundleParent).each(function() {
    const bundleDetailsContainer = $(this).closest('.hidden-bundle-details');

    if ($(this).text() == sku) {
      $(bundleDetailsContainer).css('display', 'block');
      return false;
    }
  });
}

export function getBundleSku(selectedItem) {
  return $('.choice-sku', selectedItem).text();
}

export function getChosenVariatonFromProductObj(bundleId, compareVal) {
  const maybeVariationArr = productInformationObj.bundled_item_products['_' + bundleId]?.variations;

  if (!maybeVariationArr)
    return;

  for (const variation of maybeVariationArr) {
    if (Object.values(variation.attributes)[0] === compareVal)
      return variation;
  }

  return false;
}

export function paSizeButtonStyling() {
  // Specialhantering av PA_SIZE och PA_COLOR-attributet. Ska bli dropdown istället för customlabel
  const paSizeParent = $('.label label[for^="pa_size"]').parent().parent();
  paSizeParent.addClass('pa_size_parent');
  $('.label', paSizeParent).addClass('pa_size_label');
  $('.value', paSizeParent).css('display', 'block');

  const paColorParent = $('.label label[for^="pa_color"]').parent().parent();
  paColorParent.addClass('pa_color_parent');
  $('.label', paColorParent).addClass('pa_color_label');
  $('.value', paColorParent).css('display', 'block');
}

export function updateVariationDescription(descriptionHtml) {
  $('.product-meta .product-description').html(descriptionHtml);
}
